module.exports = __webpack_public_path__ + "img/sld_acdb_mfm.83b2bcaf.svg";